import * as Types from '../../../../gql/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type DesignerQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DesignerQuery = (
  { __typename?: 'Query' }
  & { designer?: Types.Maybe<(
    { __typename?: 'Designer' }
    & Pick<Types.Designer, 'name' | 'role' | 'description' | 'location' | 'instagramLabel' | 'instagramUrl' | 'websiteLabel' | 'websiteUrl'>
    & { avatar?: Types.Maybe<(
      { __typename?: 'ContentfullAsset' }
      & Pick<Types.ContentfullAsset, 'url' | 'width' | 'height'>
    )> }
  )> }
);



export const DesignerDocument = `
    query designer($id: String!) {
  designer(id: $id) {
    name
    role
    description
    avatar {
      url
      width
      height
    }
    location
    instagramLabel
    instagramUrl
    websiteLabel
    websiteUrl
  }
}
    `;

export const useDesignerQuery = <
      TData = DesignerQuery,
      TError = unknown
    >(
      variables: DesignerQueryVariables,
      options?: Omit<UseQueryOptions<DesignerQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DesignerQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DesignerQuery, TError, TData>(
      {
    queryKey: ['designer', variables],
    queryFn: graphqlFetcher<DesignerQuery, DesignerQueryVariables>(DesignerDocument, variables),
    ...options
  }
    )};

useDesignerQuery.getKey = (variables: DesignerQueryVariables) => ['designer', variables];


useDesignerQuery.fetcher = (variables: DesignerQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<DesignerQuery, DesignerQueryVariables>(DesignerDocument, variables, options);
